// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{scroll-behavior:smooth}body{margin:0;padding:0;overflow-x:hidden}.main-enter-active,.main-leave-active{transition:all .5s}*,:after,:before{box-sizing:border-box;margin:0}.content-wrapper{position:relative}.content-wrapper.is-loading{height:100vh;overflow:hidden}.page-wrapper{position:relative;margin:0 auto;width:100%;min-height:100dvh;min-width:300px;background-color:#292929;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
